import React, { useMemo } from 'react';
import { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import { FormInputNew } from 'components/Input/FormInputNew';

interface IProps {
	changeName: (value: string) => void;
}

export const NameField: React.FC<IProps> = React.memo(({ changeName }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterName') }], [t]);

	return (
		<FormInputNew
			testId="NameField"
			name="name"
			label="nameLabel"
			validationRules={validationRules}
			onChange={changeName}
		/>
	);
});
